import { stationDayLabel } from "util/stationTime";

/**
 * How long a PURCHASED gift voucher stays redeemable: three years from the end
 * of the calendar year of purchase (PO decision 2026-10-12, §§ 195, 199 BGB) —
 * a voucher bought on 2026-10-12 is valid through 31 December 2029. The year is
 * the station's, so a purchase in the first minutes of 1 January counts for the
 * new year.
 *
 * Mirrors `giftVoucherValidUntil` in backend/src/core/utils/giftVoucherValidity.ts,
 * which stamps the real date on the voucher at checkout; this copy only tells
 * the buyer that date in advance. Both are pinned on the same dates by their
 * tests. Change them together, with the form note (`voucher_purchase.note`)
 * and the terms (DefaultTermsAndConditions 6.6).
 */
export const GIFT_VOUCHER_VALIDITY_YEARS = 3;

/** The year of 31 December on which a voucher bought at `purchasedAt` expires. */
export const giftVoucherValidUntilYear = (purchasedAt: Date): number =>
  Number(stationDayLabel(purchasedAt).slice(0, 4)) + GIFT_VOUCHER_VALIDITY_YEARS;
